module.exports = __webpack_public_path__ + "media/src/images/icon-down-arrow-3505bf3f49ba936e23f879c1d28bef2c.svg";